/** Standard min-width for marketing CTAs (CMS Link, CTA button, CTAGroup). */
export const CTA_DEFAULT_MIN_WIDTH = 240;
